import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon, GiftIcon, ImagePlayIcon, LibraryIcon, ZapIcon } from 'lucide-react';
const helps = ['comprender el origen del irezumi', 'descubrir el significado de sus símbolos', 'explorar la mitología japonesa', 'entender la composición corporal', 'conocer la filosofía samurái', 'acceder a una enorme galería visual de referencia'];
const includes = [{
  icon: BookOpenIcon,
  text: '8 módulos completos'
}, {
  icon: GiftIcon,
  text: '6 bonus premium'
}, {
  icon: ImagePlayIcon,
  text: 'Atlas visual'
}, {
  icon: LibraryIcon,
  text: 'Galerías exclusivas'
}, {
  icon: ZapIcon,
  text: 'Acceso inmediato'
}];
export function ProductPresentation() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-309">
      <div className="max-w-4xl mx-auto" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-311">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-312">
            <span className="text-xs font-bold tracking-widest" data-id="element-313">
              🏆 LA COLECCIÓN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-314">
            Una biblioteca visual dedicada al{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-315">
              tatuaje japonés
            </span>
          </h2>
          <p className="font-serif-italic text-rose text-lg md:text-xl mt-4" data-id="element-316">
            8 Módulos + 6 Bonus Premium
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-bg-warm border border-line rounded-3xl p-7 md:p-10 mb-8 shadow-sm" data-id="element-317">
          <p className="text-ink-soft text-base md:text-lg mb-5" data-id="element-318">
            Esta colección fue creada para ayudarte a:
          </p>
          <ul className="space-y-3 mb-2" data-id="element-319">
            {helps.map((h, i) => <li key={i} className="flex items-center gap-3" data-id="element-320">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-rose/10 flex items-center justify-center" data-id="element-321">
                  <CheckIcon className="w-3.5 h-3.5 text-rose" strokeWidth={3} data-id="element-322" />
                </span>
                <span className="text-ink" data-id="element-323">{h}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-324">
          {includes.map((it, i) => <div key={i} className="flex items-center gap-3 bg-bg-warm border border-line rounded-2xl px-4 py-3.5 shadow-sm" data-id="element-325">
              <span className="flex-shrink-0 w-10 h-10 rounded-xl bg-rose/10 flex items-center justify-center" data-id="element-326">
                <it.icon className="w-4 h-4 text-rose" data-id="element-327" />
              </span>
              <span className="font-semibold text-ink text-sm" data-id="element-328">{it.text}</span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}